const tableSchemaBase = [
	{
		accessor: 'site',
		title: 'global.site',
		defaultVisible: true,
		fixed: true,
		footerType: 'sumSitesProductions',
	},
	{
		accessor: 'startDate',
		title: 'global.startDate',
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'quantityConverted',
		title: 'global.quantity',
		defaultVisible: true,
		fixed: true,
		footerType: 'sumProductions',
	},
	{
		accessor: 'tokenEquivalent',
		title: 'global.tokenEquivalent',
		defaultVisible: true,
		fixed: true,
		footerType: 'sumTokenEquivalents',
	},
	{
		type: 'showAction',
		accessor: '',
		title: null,
		resizable: true,
		defaultVisible: true,
	},
];

export { tableSchemaBase };
